<ion-content>
  <div class="constrained-content">
    <ion-grid>
      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="text-outline"></ion-icon> Project Details</h1>
          <p class="subtitle">Basic information about your project.</p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-item lines="full">
                <ion-label class="input-label" position="stacked">
                  Name <ion-text color="warning" *ngIf="!id">(Required)</ion-text></ion-label
                >
                <ion-input
                  #nameInput
                  class="input-field"
                  [(ngModel)]="name"
                  type="text"
                  placeholder="e.g. Customer Support"
                  style="padding: 0 10px 0 10px !important"
                ></ion-input>
              </ion-item>
              <ion-item lines="full">
                <ion-label position="stacked" class="input-label">Description</ion-label>
                <ion-textarea
                  style="padding: 0 10px 0 10px !important"
                  class="input-field"
                  #descriptionInput
                  [(ngModel)]="description"
                  placeholder="e.g. Issues related to information technology and hardware"
                ></ion-textarea>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="person-circle-outline"></ion-icon> Bot Configuration</h1>
          <p class="subtitle">Customize the appearance of the bot for your support team as it appears in Slack.</p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-item>
                <div class="notification-preview">
                  <div
                    class="notification-icon"
                    style="
                      width: 50px;
                      height: 50px;
                      border-radius: 8px;
                      border: 1px solid var(--input-border-color);
                      margin-top: 8px;
                    "
                  >
                    <ion-button
                      slot="end"
                      size="full"
                      fill="clear"
                      (click)="uploadSupportLogo()"
                      class="icon-upload-button"
                    >
                      <ion-icon name="cloud-upload-outline" [ngClass]="{ hide: !!supportLogo }"></ion-icon>
                    </ion-button>
                    <img *ngIf="supportLogo" [src]="supportLogo" />
                  </div>
                </div>
                <ion-item lines="full">
                  <ion-input
                    [(ngModel)]="supportName"
                    placeholder="Unthread"
                    class="select-outline"
                    style="padding: 0 10px 0 10px !important"
                  ></ion-input>
                </ion-item>
              </ion-item>
              <ion-item [hidden]="!id">
                <ion-label position="stacked">AI Agent Instructions</ion-label>
                <ion-textarea
                  style="padding: 0 10px 0 10px !important"
                  class="input-field"
                  [(ngModel)]="instructions"
                  placeholder="Specific instructions for the AI agent handling this project. e.g. Use a friendly tone, request specific details when handling tickets."
                  autoGrow="true"
                  rows="4"
                ></ion-textarea>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="git-commit-outline"></ion-icon> Support Steps & SLAs</h1>
          <p class="subtitle">
            Define the steps and service level agreements for handling conversations in this project.
          </p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <app-support-steps
                [isDefaults]="false"
                [projectId]="id"
                [initialSupportSteps]="supportSteps"
                (stepsDidChange)="supportStepsDidChange($event)"
              ></app-support-steps>
            </ion-card-content>
          </ion-card>
          <a href="https://docs.unthread.io/conversations/slas" target="_blank" class="settings-learn-more">
            <ion-icon name="book-outline"></ion-icon>
            Learn more about SLAs and assignment rules
          </a>
        </ion-col>
      </ion-row>

      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="settings-outline"></ion-icon> Project Configuration</h1>
          <p class="subtitle">Manage detailed settings for triage, ticket types, and working hours.</p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-item lines="full">
                <ion-label>Default Triage Channel</ion-label>
                <app-channel-selector
                  [channel]="defaultTriageChannel"
                  (channelDidChange)="channelDidChange($event)"
                  [defaultInternalOnly]="true"
                  [defaultExternalOnly]="false"
                  [hideChannelTypeFilter]="true"
                  [hideSecondaryTeams]="false"
                >
                </app-channel-selector>
              </ion-item>
              <ion-item lines="full" button (click)="setDefaultTicketType()" detail="false">
                <ion-label>Default Ticket Type</ion-label>
                <ion-text slot="end" *ngIf="!defaultTicketType" color="medium">Select Ticket Type</ion-text>
                <ion-text slot="end" *ngIf="defaultTicketType">{{ defaultTicketType.name }}</ion-text>
                <ion-icon name="chevron-down-outline" slot="end" *ngIf="!defaultTicketType"></ion-icon>
                <ion-icon
                  name="close-circle-outline"
                  slot="end"
                  *ngIf="defaultTicketType"
                  (click)="$event.stopPropagation(); defaultTicketType = null"
                ></ion-icon>
              </ion-item>
              <ion-item lines="full" button (click)="setTriageMessageTemplate()" detail="false">
                <ion-label>Triage Message Template</ion-label>
                <ion-text slot="end" *ngIf="!triageMessageTemplate" color="medium">Select Template</ion-text>
                <ion-text slot="end" *ngIf="triageMessageTemplate">{{ triageMessageTemplate.name }}</ion-text>
                <ion-icon name="chevron-down-outline" slot="end" *ngIf="!triageMessageTemplate"></ion-icon>
                <ion-icon
                  name="close-circle-outline"
                  slot="end"
                  *ngIf="triageMessageTemplate"
                  (click)="$event.stopPropagation(); triageMessageTemplateId = null; triageMessageTemplate = null"
                ></ion-icon>
              </ion-item>
              <ion-item lines="none" button (click)="manageWorkingHours()">
                <ion-label>Working Hours</ion-label>
                <ion-text slot="end">{{ workingHoursEnabled ? 'Enabled' : 'Disabled' }}</ion-text>
                <ion-icon name="chevron-forward-outline" slot="end"></ion-icon>
              </ion-item>
            </ion-card-content>
          </ion-card>
          <a
            href="https://docs.unthread.io/conversations/triaging"
            target="_blank"
            class="settings-learn-more small-learn-more"
          >
            <ion-icon name="book-outline"></ion-icon>
            Learn more about triaging
          </a>
        </ion-col>
      </ion-row>

      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="eye-outline"></ion-icon> Visibility</h1>
          <p class="subtitle">Control who can see and interact with this project.</p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-list>
                <ion-radio-group [(ngModel)]="visibility" name="visibility">
                  <ion-item lines="full">
                    <ion-icon name="lock-open-outline" slot="start" class="medium-icon"></ion-icon>
                    <ion-label text-wrap>
                      <h2>Public</h2>
                      <p>Anyone in your workspace can see this project and its associated conversations.</p>
                    </ion-label>
                    <ion-radio slot="end" value="public"></ion-radio>
                  </ion-item>
                  <ion-item lines="none">
                    <ion-icon name="lock-closed-outline" slot="start" class="medium-icon"></ion-icon>
                    <ion-label text-wrap>
                      <h2>Restricted</h2>
                      <p>Only you can see this project and its associated conversations.</p>
                    </ion-label>
                    <ion-radio slot="end" value="restricted"></ion-radio>
                  </ion-item>
                </ion-radio-group>
              </ion-list>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>

      <ion-row class="row">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="briefcase-outline"></ion-icon> Type</h1>
          <p class="subtitle">Configure if this project handles external or internal support.</p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-item lines="none">
                <ion-label text-wrap>
                  <h2>Is this an external customer project?</h2>
                  <p>External projects are used to manage support for customers outside your organization.</p>
                </ion-label>
                <label class="switch" slot="end">
                  <input type="checkbox" [(ngModel)]="isExternal" />
                  <span class="slider"></span>
                </label>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
      <ion-row class="row" *ngIf="showEscalationSettings">
        <ion-col size-md="5" size="12" class="settings-title-section">
          <h1><ion-icon name="alert-circle-outline"></ion-icon> Escalation Settings</h1>
          <p class="subtitle">Configure the escalation settings for this project.</p>
        </ion-col>
        <ion-col size-md="7" size="12">
          <ion-card class="outline-card">
            <ion-card-content>
              <ion-item lines="none">
                <ion-label text-wrap>
                  <h2>Send user-facing notifications</h2>
                  <p>
                    When enabled, the support bot will send a notification to the main conversation thread when an
                    escalation occurs.
                  </p>
                </ion-label>
                <label class="switch" slot="end">
                  <input type="checkbox" [(ngModel)]="escalationSettings.sendUserFacingNotifications" />
                  <span class="slider"></span>
                </label>
              </ion-item>
            </ion-card-content>
          </ion-card>
        </ion-col>
      </ion-row>
    </ion-grid>
  </div>
</ion-content>

<ion-footer class="footer">
  <div class="constrained-content flex-space-between">
    <div>
      <ion-button (click)="submit()" [disabled]="isLoading">
        Save
        <ion-spinner name="crescent" [hidden]="!isLoading" style="margin-left: 10px"></ion-spinner>
      </ion-button>
      <ion-button (click)="viewInInbox()" fill="clear" color="dark" [disabled]="isLoading" [hidden]="!id">
        <ion-icon name="file-tray-outline"></ion-icon>
        <span class="hidden-sm text-with-left-icon">View conversations</span>
      </ion-button>
    </div>
    <ion-button
      fill="clear"
      color="dark"
      (click)="delete()"
      [disabled]="isLoading"
      *ngIf="id"
      ngxTippy
      data-tippy-content="Delete"
    >
      <ion-icon name="trash-outline"></ion-icon>
    </ion-button>
  </div>
</ion-footer>
